const defaults = {
	menuItemSelector: '.menu-item',
	currentMenuItemClassname: 'current-menu-item',
	menuLinkSelector: 'a',
};

export default function(element, options = {}) {
	const params = { ...defaults, ...options };
	const menuItems = element.querySelectorAll(params.menuItemSelector);
	const menuLinks = element.querySelectorAll(`${params.menuItemSelector} ${params.menuLinkSelector}`);
	
	// Créer une map pour associer les sections aux éléments de menu
	const sectionMap = new Map(); // section -> menuItem
	
	menuLinks.forEach(link => {
		const href = link.getAttribute('href');
		if (href && href.startsWith('#')) {
			const sectionId = href.substring(1);
			const section = document.getElementById(sectionId);
			const menuItem = link.closest(params.menuItemSelector);
			
			if (section && menuItem) {
				sectionMap.set(section, menuItem);
			}
		}
	});

	if (sectionMap.size === 0) return;

	// Stocker les états d'intersection de chaque section
	const intersectionStates = new Map();

	// Options pour l'IntersectionObserver
	const ioOptions = {
		root: null, // viewport
		rootMargin: '-20% 0px -60% 0px', // Déclenche quand la section est dans le tiers supérieur du viewport
		threshold: [0, 0.1, 0.25, 0.5, 0.75, 1.0] // Plusieurs seuils pour une détection précise
	};

	// Fonction pour déterminer quelle section est la plus "active"
	const getActiveSection = () => {
		const visibleSections = Array.from(intersectionStates.entries())
			.filter(([section, isIntersecting]) => isIntersecting)
			.map(([section]) => section);

		if (visibleSections.length === 0) {
			// Si aucune section n'est visible, vérifier si on est en haut de page
			if (window.scrollY < 100) {
				return Array.from(sectionMap.keys())[0]; // Première section
			}
			return null;
		}

		// Trier par position dans le document (la plus haute = priorité)
		visibleSections.sort((a, b) => {
			const rectA = a.getBoundingClientRect();
			const rectB = b.getBoundingClientRect();
			// Prioriser la section la plus proche du haut du viewport
			return rectA.top - rectB.top;
		});

		return visibleSections[0];
	};

	// Fonction pour mettre à jour l'état actif du menu
	const updateActiveMenuItem = () => {
		// Retirer la classe current-menu-item de tous les éléments
		menuItems.forEach(item => {
			item.classList.remove(params.currentMenuItemClassname);
		});

		// Trouver la section active
		const activeSection = getActiveSection();
		if (activeSection) {
			const activeMenuItem = sectionMap.get(activeSection);
			if (activeMenuItem) {
				activeMenuItem.classList.add(params.currentMenuItemClassname);
			}
		}
	};

	// Callback pour gérer les intersections
	const callback = (entries) => {
		entries.forEach(entry => {
			intersectionStates.set(entry.target, entry.isIntersecting);
		});
		updateActiveMenuItem();
	};

	// Créer l'observer
	const observer = new IntersectionObserver(callback, ioOptions);

	// Observer toutes les sections et initialiser les états
	sectionMap.forEach((menuItem, section) => {
		observer.observe(section);
		// Initialiser l'état (sera mis à jour par le callback)
		intersectionStates.set(section, false);
	});

	// Initialiser l'état au chargement de la page
	// Forcer une vérification initiale après un court délai
	setTimeout(() => {
		Array.from(sectionMap.keys()).forEach(section => {
			const rect = section.getBoundingClientRect();
			const isVisible = rect.top < window.innerHeight * 0.3 && rect.bottom > 0;
			intersectionStates.set(section, isVisible);
		});
		updateActiveMenuItem();
	}, 100);
};